import { SVGInterface } from "../../interface";

const CircleClose = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.0062 22.0044C7.95972 22.0068 4.31066 19.5703 2.76183 15.832C1.213 12.0937 2.0697 7.79046 4.93216 4.93037C7.45946 2.40308 11.1431 1.41606 14.5954 2.34111C18.0478 3.26617 20.7444 5.96276 21.6694 9.41511C22.5945 12.8675 21.6075 16.5511 19.0802 19.0784C17.2076 20.9594 14.6603 22.013 12.0062 22.0044ZM4.00616 12.1764C4.05348 16.5776 7.64727 20.1139 12.0487 20.0904C16.4501 20.0666 20.0057 16.4919 20.0057 12.0904C20.0057 7.68888 16.4501 4.11415 12.0487 4.09037C7.64727 4.06683 4.05348 7.60313 4.00616 12.0044V12.1764ZM9.41516 16.0044L8.00616 14.5944L10.5962 12.0044L8.00616 9.41437L9.41616 8.00437L12.0062 10.5944L14.5962 8.00437L16.0062 9.41437L13.4162 12.0044L16.0062 14.5944L14.5972 16.0044L12.0062 13.4144L9.41616 16.0044H9.41516Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CircleClose;
